import React from 'react'

const editPencilIcon = (props: any) => {
    const { fill} = props;
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4991 0.704746C12.2767 0.481379 12.0124 0.304137 11.7213 0.183197C11.4302 0.062257 11.1181 0 10.8029 0C10.4877 0 10.1756 0.062257 9.88452 0.183197C9.59344 0.304137 9.32911 0.481379 9.10671 0.704746L0.495914 9.33755C0.426952 9.40785 0.383571 9.49926 0.372714 9.59715L0.00311381 12.7079C-0.00472373 12.7735 0.00228003 12.8399 0.0236062 12.9024C0.0449324 12.9648 0.0800346 13.0217 0.126314 13.0687C0.167582 13.1109 0.216892 13.1442 0.271313 13.1669C0.325735 13.1896 0.384158 13.2011 0.443114 13.2007H0.491514L3.62871 12.8751C3.72871 12.864 3.82189 12.819 3.89271 12.7475L12.4991 4.11035C12.9489 3.65777 13.2014 3.04562 13.2014 2.40755C13.2014 1.76948 12.9489 1.15732 12.4991 0.704746ZM3.38231 12.0083L0.944714 12.2679L1.22631 9.85235L8.02872 3.03235L10.1803 5.18835L3.38231 12.0083ZM10.8007 4.56795L8.64911 2.40755L9.72711 1.32075C10.0166 1.04167 10.403 0.885735 10.8051 0.885735C11.2072 0.885735 11.5936 1.04167 11.8831 1.32075C12.1685 1.60694 12.3287 1.9946 12.3287 2.39875C12.3287 2.80289 12.1685 3.19055 11.8831 3.47675L10.8007 4.56795Z"
        fill={fill}
      />
    </svg>
  );
}

export default editPencilIcon;